import type { SelectorAttribute } from '../types';

export function getSelectorAttribute(selector: string): SelectorAttribute {
  return {
    ['data-cy']: selector,
  };
}